import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLang } from "@/lib/LangContext";
import { BUSINESS } from "@/lib/business";
import Logo from "@/components/Logo";
import { Globe, Phone } from "lucide-react";

export default function Header({ active }) {
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[#6B1F27]/15"
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 shrink-0" translate="no">
          <Logo size={40} variant="dark" />
          <div className="leading-none">
            <div className="font-display text-lg tracking-tighter notranslate" translate="no">{BUSINESS.name}</div>
            <div className="tick-label mt-1 hidden sm:block">{BUSINESS.tagline[lang]}</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          <a
            href="/#services"
            data-testid="nav-services"
            className={`text-sm font-medium ${active === "services" ? "text-[#6B1F27]" : "text-neutral-800 hover:text-[#6B1F27]"} transition-colors`}
          >
            {t.nav.services}
          </a>
          <Link
            to="/book"
            data-testid="nav-book"
            className={`text-sm font-medium ${active === "book" ? "text-[#6B1F27]" : "text-neutral-800 hover:text-[#6B1F27]"} transition-colors`}
          >
            {t.nav.book}
          </Link>
          <Link
            to="/track"
            data-testid="nav-track"
            className={`text-sm font-medium ${active === "track" ? "text-[#6B1F27]" : "text-neutral-800 hover:text-[#6B1F27]"} transition-colors`}
          >
            {lang === "es" ? "Rastrear" : "Track"}
          </Link>
          <a
            href="/#contact"
            data-testid="nav-contact"
            className="text-sm font-medium text-neutral-800 hover:text-[#6B1F27] transition-colors"
          >
            {lang === "es" ? "Contacto" : "Contact"}
          </a>
          <Link
            to="/admin"
            data-testid="nav-admin"
            className={`text-sm font-medium ${active === "admin" ? "text-[#6B1F27]" : "text-neutral-800 hover:text-[#6B1F27]"} transition-colors`}
          >
            {t.nav.admin}
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${BUSINESS.phone_raw}`}
            data-testid="header-phone"
            className="hidden lg:flex items-center gap-2 text-sm font-mono-tight hover:text-[#6B1F27] transition-colors"
          >
            <Phone size={14} /> {BUSINESS.phone_display}
          </a>
          <button
            data-testid="lang-toggle"
            onClick={() => setLang(lang === "es" ? "en" : "es")}
            className="tick-label flex items-center gap-2 hover:text-[#6B1F27] transition-colors"
          >
            <Globe size={14} />
            <span>{lang === "es" ? "ES / EN" : "EN / ES"}</span>
          </button>
          <button
            data-testid="header-book-btn"
            onClick={() => navigate("/book")}
            className="btn-primary text-sm hidden md:inline-flex"
          >
            {t.nav.book} →
          </button>
        </div>
      </div>
    </header>
  );
}
